import React from "react";
import { Icon, IconName } from "../icon";

import "./badge.css";

/** Only the badge component */
export const Badge = ({
	value,
	iconName,
	className,
}: {
	value?: string;
	iconName?: IconName;
	className?: string;
}) => {
	if (!iconName && !value) return null;
	return (
		<div className={`badge ${iconName ? "badge--is-icon" : ""} ${className || ""}`}>
			{iconName ? <Icon iconName={iconName} /> : value}
		</div>
	);
};
Badge.displayName = "Badge";

/** Wrap your component with this component to add a badge around it */
export const BadgeWrapper = ({
	value,
	iconName,
	className,
	badgeClassName,
	children,
}: React.PropsWithChildren<{
	value?: string;
	iconName?: IconName;
	className?: string;
	badgeClassName?: string;
}>) => (
	<div className={`badge__wrapper ${className || ""}`}>
		{children}
		<Badge className={badgeClassName} value={value} iconName={iconName} />
	</div>
);
BadgeWrapper.displayName = "BadgeWrapper";
